module.exports = __webpack_public_path__ + "img/timer-catch.18815980.svg";